/**
 * Razones financieras y análisis de insolvencia.
 *
 * Todo indicador se almacena como FRACCIÓN y el ×100 se hace aquí. Guardar
 * unos multiplicados y otros no —que es lo que hoy hacen ROA y ROE frente al
 * margen bruto— produce columnas contiguas en unidades distintas.
 */

import { StatusBadge } from "../../components/StatusBadge";
import { formatRatio } from "../../components/format";
import { useClosing } from "./closingContext";
import { StatementHead } from "./shared";

export function Ratios() {
  const { package: pkg } = useClosing();
  const insolvencia = pkg.insolvency;

  return (
    <>
      <StatementHead
        title="Razones Financieras"
        subtitle={`diagnóstico al ${pkg.period_to}`}
        homologation={pkg.homologation.financial_ratios}
      />

      <div className="card">
        <div className="table-wrap documento">
          <table>
            <thead>
              <tr>
                <th scope="col">Indicador</th>
                <th scope="col">Fórmula</th>
                <th scope="col" className="num">
                  A {pkg.period_to}
                </th>
                <th scope="col">Ideal</th>
              </tr>
            </thead>
            <tbody>
              {pkg.ratios.map((ratio) => (
                <tr key={ratio.id}>
                  <td>{ratio.label}</td>
                  <td className="small muted">{ratio.description}</td>
                  <td className="num">{formatRatio(ratio.value, ratio.format)}</td>
                  <td className="small muted">{ratio.ideal ?? ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h2>{insolvencia.label}</h2>
        {insolvencia.status === "pending_definition" && (
          <div className="banner" style={{ marginBottom: 12 }}>
            <StatusBadge tone="serious">Pendiente de definición</StatusBadge>
            <div className="banner-body">
              <strong>El índice agregado no se publica</strong>
              <p className="small muted">
                {insolvencia.pending_note} La hoja de cálculo original sumaba
                X1+X2+X3+X4 sin coeficientes, que no corresponde a ningún modelo
                publicado; los componentes sí son ratios legítimos y se muestran.
              </p>
            </div>
          </div>
        )}
        <div className="table-wrap documento">
          <table>
            <thead>
              <tr>
                <th scope="col">Componente</th>
                <th scope="col">Definición</th>
                <th scope="col" className="num">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody>
              {insolvencia.components.map((component) => (
                <tr key={component.id}>
                  <td className="mono">{component.id}</td>
                  <td>{component.label}</td>
                  <td className="num">{formatRatio(component.value, "ratio")}</td>
                </tr>
              ))}
              <tr className="level-1">
                <td colSpan={2}>Índice</td>
                <td className="num">
                  {insolvencia.index === null
                    ? "Pendiente de definición"
                    : formatRatio(insolvencia.index, "ratio")}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
